import type { Color, PaletteColor, PaletteColorOptions } from '@mui/material';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import type { ThemeOptions } from '@mui/material/styles';
import type { ColorPartial } from '@mui/material/styles/createPalette';
import { PropsWithChildren } from 'react';

import type {} from '@mui/x-data-grid-pro/themeAugmentation';
import { muiAppBarThemeConfig } from '../themes/muiAppBarThemeConfig';
import { muiButtonThemeConfig } from '../themes/muiButtonThemeConfig';
import { muiChipThemeConfig } from '../themes/muiChipThemeConfig';
import { dataGridThemeConfig, tableRowThemeConfig } from '../themes/muiDataGridThemeConfig';
import { muiListItemThemeConfig } from '../themes/muiListItem';
import { muiMenuThemeConfig } from '../themes/muiMenuThemeConfig';
import { muiTypographyThemeConfig } from '../themes/muiTypographyThemeConfig';
import { paletteFigmaThemeConfig } from '../themes/paletteFigmaThemeConfig';
import { typographyFigmaThemeConfig } from '../themes/typographyFigmaThemeConfig';

export const themeOptions: ThemeOptions = {
  palette: {
    //...paletteThemeConfig,
    ...paletteFigmaThemeConfig,
  },
  typography: {
    //...typographyThemeConfig,
    ...typographyFigmaThemeConfig,
  },
  components: {
    ...muiTypographyThemeConfig,
    ...muiAppBarThemeConfig,
    ...muiButtonThemeConfig,
    ...muiMenuThemeConfig,
    MuiDataGrid: {
      ...dataGridThemeConfig,
    },
    MuiTableRow: {
      ...tableRowThemeConfig,
    },
    ...muiChipThemeConfig,
    ...muiListItemThemeConfig,
  },

  spacing: 4, // base spacing unit
};

declare module '@mui/material/styles' {
  interface ExtraTertiaryColorsPalette {
    lightBlue: string;
    blue: string;
    darkBlue: string;
    green: string;
    teal: string;
    yellow: string;
    orange: string;
    lightGray: string;
    black: string;
  }

  interface Palette {
    cardBackground: PaletteColor;
    white: PaletteColor;
    blue: Color & PaletteColor;
    indigo: Color & PaletteColor;
    deeppurple: Color & PaletteColor;
    amber: Color & PaletteColor;
    orange: Color & PaletteColor;
    pink: Color & PaletteColor;
    deeporange: Color & PaletteColor;
    green: Color & PaletteColor;
    red: Color & PaletteColor;
    lightgreen: Color & PaletteColor;
    purple: Color & PaletteColor;
    lime: Color & PaletteColor;
    lightblue: Color & PaletteColor;
    cyan: Color & PaletteColor;
    teal: Color & PaletteColor;
    yellow: Color & PaletteColor;
    bluegrey: Color & PaletteColor;
    tertiary: ExtraTertiaryColorsPalette;
  }

  interface PaletteOptions {
    cardBackground?: PaletteColorOptions;
    white?: PaletteColorOptions;
    blue?: ColorPartial & PaletteColorOptions;
    indigo?: ColorPartial & PaletteColorOptions;
    deeppurple?: ColorPartial & PaletteColorOptions;
    amber?: ColorPartial & PaletteColorOptions;
    orange?: ColorPartial & PaletteColorOptions;
    pink?: ColorPartial & PaletteColorOptions;
    deeporange?: ColorPartial & PaletteColorOptions;
    green?: ColorPartial & PaletteColorOptions;
    red?: ColorPartial & PaletteColorOptions;
    lightgreen?: ColorPartial & PaletteColorOptions;
    purple?: ColorPartial & PaletteColorOptions;
    lime?: ColorPartial & PaletteColorOptions;
    lightblue?: ColorPartial & PaletteColorOptions;
    cyan?: ColorPartial & PaletteColorOptions;
    teal?: ColorPartial & PaletteColorOptions;
    yellow?: ColorPartial & PaletteColorOptions;
    bluegrey?: ColorPartial & PaletteColorOptions;
    tertiary: Partial<ExtraTertiaryColorsPalette>;
  }
}

//export let theme = createTheme(themeOptions);
export const theme = createTheme(themeOptions);

export const AppThemeProvider = (props: PropsWithChildren) => {
  return <ThemeProvider theme={theme}>{props.children}</ThemeProvider>;
};

export default AppThemeProvider;
